import axiosPrivate from "../../../api/axiosPrivate";
import {
  CREATE_CHARGE,
  GET_ALL_CHARGE,
  GET_SINGLE_CHARGE,
  UNPAGINATED_CHARGES,
  UPDATE_CHARGE,
} from "../../../api/constant";

// Create new role
const createCharge = async (data) => {
  const response = await axiosPrivate.post(CREATE_CHARGE, data);
  return response.data;
};

const getAllCharges = async (pageNum) => {
  const response = await axiosPrivate.get(`${GET_ALL_CHARGE}?page=${pageNum}`);
  return response.data;
};

const getSingleCharge = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_CHARGE}/${id}`);
  return response.data;
};

const getUnpaginatedCharges = async () => {
  const response = await axiosPrivate.get(UNPAGINATED_CHARGES);
  return response.data;
};

const updateCharge = async (data) => {
  const response = await axiosPrivate.post(`${UPDATE_CHARGE}/${data.id}`, data);
  return response.data;
};

const chargesService = {
  createCharge,
  getAllCharges,
  getSingleCharge,
  updateCharge,
  getUnpaginatedCharges,
};
export default chargesService;
